module.exports = __webpack_public_path__ + "static/img/title1.dddd152.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page4/title1.png
// module id = 7rXK
// module chunks = 0